export const ADD_IMAGE = 'ADD_IMAGE';


export const addImage = data => ({
  type: ADD_IMAGE,
  data 
});